<template>
    <div class="topGetOrders">
        <div class="topView">
            <div class="getOrdersLeft">
                <div v-if="false" class="getOrder24"></div>
                <div v-if="false" class="getOrderMiss"></div>
            </div>
            <div class="getOrdersRight">
                <div v-if="isHaveDialogue==false" class="nowGoConsult" @click="nowGoConsultClick">立即咨询</div>
                <div v-else class="nowGoConsult">您正在进行咨询</div>
            </div>
        </div>
        <!--底部的老师及详细的聊天内容-->
        <div class="bottomAskView">
            <!--是否有正在咨询的老师-->
            <div class="isHaveDialogue" v-if="isHaveDialogue==true&&isShowDialogue==false">
                <div class="dialoguLeftText">您正在向一位老师进行咨询，点击右侧“返回咨询”继续咨询。</div>
                <div class="dialoguGointoBtn">
                    <div class="gointoBtn" @click="haveDialogBtn" v-loading="goLoading">返回咨询</div>
                </div>
            </div>
            <!--专家列表-->
            <div class="isShowTeacherView" v-if="isShowTeacherView" v-loading="listLoading">
                <!--24小时稽查问题处理-->
                <div class="teacherJinJi">
                    <div class="teacherJinJiText">
                        <p>24小时稽查问题处理</p>
                    </div>
                    <div class="jinjiRight">
                        <div class="jinjiBtn" @click="jinjiAsk">紧急咨询</div>
                    </div>
                </div>
                <!--常规专家列表-->
                <div class="teacherCG">
                    <div class="teacherCGNav">
                        <p>常规问题处理</p>
                    </div>
                    <div class="teacherListBox">
                        <div class="teacherList" :class="teacherMPIndex==index?'teacherListCheck':''" v-for="(item,index) in teacherList" :key="index">
                            <div class="checkedBorder"></div>
                            <div class="teacherStatus" v-if="item.status == 0">
                                <span>休息中</span>
                            </div>
                            <div class="teacherListTop">
                                <div class="teacherHeader">
                                    <img :src="imgObj.img_header" alt="">
                                </div>
                                <div class="teacherDesc">
                                    <p>{{ item.goodAt }}</p>
                                </div>
                            </div>
                            <div class="teacherListBottom">
                                <div class="teacherBottomLeft">
                                    <div class="teacherName">{{ item.userName }}</div>
                                    <div class="teacherMP">
                                        <div class="teacherMPD" @click="openMP(item,index)">
                                            <img :src="imgObj.icon_mp" alt="">
                                            <span>名片</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="teacherBottomRight">
                                    <div v-if="item.status == 0" class="teacherStartSialogue status0" @click="teacherClick(item,index)">查看记录</div>
                                    <div v-else class="teacherStartSialogue" @click="teacherClick(item,index)">
                                        <span v-if="dialogueTeacherId==item.userId">继续咨询</span>
                                        <span>立即咨询</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--专家名片-->
                    <div class="teacherMPView" :class="mpDirection=='left'?'teacherMPViewL':''" v-if="isShowTeacherMP">
                        <div class="closeMPView" @click="closeMP">×</div>
                        <div class="teacherMPTop">
                            <div class="teacherMPHeader">
                                <img :src="imgObj.img_header" alt="">
                            </div>
                            <div class="teacherMPn">
                                <p class="teacherName">{{ teacherMPDetail.userName }}</p>
                                <p class="teacherLevel">
                                    <img :src="imgObj.icon_level" alt="">
                                    <span>特邀专家</span>
                                </p>
                            </div>
                        </div>
                        <div class="teacherMPBottom">
                            <div class="teacherSC">个人擅长</div>
                            <div class="teacherText">
                                <p>{{ teacherMPDetail.goodAt }}</p>
                            </div>
                            <div class="teacherSC">个人成果</div>
                            <div class="teacherText">
                                <p v-html="teacherMPDetail.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--聊天内容模块-->
            <div class="chatBox" v-if="isShowDialogue">
                <div class="chatTopNav">
                    <div class="chatTopNavLeft">
                        <div class="chatTopNavReturn" @click="returnTeacherList">
                            <div class="chatTopNavReturnIcon">{{ leftJ }}</div>
                            <span class="chatTopNavReturnText">返回</span>
                        </div>
                    </div>
                    <div class="chatTopNavText" v-if="isHaveDialogue==true">
                        <p>
                            <span>如您已完成咨询，请您点击</span>
                            <span class="redSpan">“结束服务”</span>
                            <span>，才可以对其他老师进行咨询呦！</span>
                        </p>
                    </div>
                    <div class="chatTopNavRight" v-if="isHaveDialogue==true">
                        <div class="chatTopNavOverBtn" @click="overThatAsk">结束咨询</div>
                    </div>
                </div>
                <div class="chatBody">
                    <chatView :sendData="sendChatData" ref='chatView' @emitOver="emitOverFN" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

//引入图片
import img_header from '@/assets/images/swjcw/header.png'
import icon_mp from '@/assets/images/swjcw/icon_mp.png'
import icon_level from '@/assets/images/swjcw/icon_level.png'

//引入接口
import { getTeacherData,getTeacherDialoging } from '@/api/askApi.js'

//引入模块
import chatView from '../chatView/index.vue'

export default {
    name:'',
    components:{
        chatView
    },
    data(){
        return{
            //图片地址
            imgObj: {
                img_header,
                icon_mp,
                icon_level
            },
            //24小时接单相关
            leftJ:'<',//'〈',
            listLoading:false,
            //是否有正在沟通中的专家
            isHaveDialogue:false,
            dialogueTeacherId:'',
            //是否展示专家列表
            isShowTeacherView:false,
            //返回咨询的loading
            goLoading:false,
            //专家列表
            teacherListAll:[],
            teacherList:[],
            teacherMPIndex:null,
            teacherListJinJi:{},
            //是否展示名片
            isShowTeacherMP:false,
            //名片展示的方向
            mpDirection:'',
            //名片内容
            teacherMPDetail:{},
            //是否展示聊天内容
            isShowDialogue:false,
            //发送给聊天页面的参数
            sendChatData:{},
        }
    },
    created(){

    },
    mounted(){
        //获取数据 是否存在正在沟通中的专家
        this.getLastDialogUserId()
        //this.getTeacherList();
    },
    methods:{

        //获取数据 是否存在正在沟通中的专家
        getLastDialogUserId(){
            this.listLoading = true
            getTeacherDialoging().then(res => {
                if(res.status==200){
                    if(res.data.status==0){
                        this.dialogueTeacherId = res.data.data;
                        this.isHaveDialogue = true;
                    }else{
                        this.dialogueTeacherId = '';
                        this.isHaveDialogue = false;
                    }
                }
                this.listLoading = false
            })
        },
        //获取专家列表
        getTeacherList(type){
            getTeacherData({}).then(res => {
                //console.log(res)
                if(res.status == 200&&res.data.status == 0){
                    let tRes = res.data.rows
                    //紧急ai问的专家和其他专家分离
                    let jinjiObj = {}
                    let newArr = []
                    for(let a=0;a<tRes.length;a++){
                        if(tRes[a].userName == "AI问紧急咨询"){
                            jinjiObj = tRes[a]
                        }else{
                            newArr.push(tRes[a])
                        }
                    }
                    //console.log(jinjiObj)
                    //console.log(newArr)
                    this.teacherListJinJi = jinjiObj;
                    //其他专家
                    this.teacherList = newArr;
                    //所有专家
                    this.teacherListAll = tRes;
                    //是否是返回专家咨询
                    if(type&&type=='go'){
                        for(let a=0;a<this.teacherListAll.length;a++){
                            if(this.teacherListAll[a].userId == this.dialogueTeacherId){
                                this.sendChatData = this.teacherListAll[a];
                                this.sendChatData.dialogueTeacherId = this.dialogueTeacherId;
                                
                                //关闭专家模块
                                this.isShowTeacherView = false;
                                //打开聊天模块
                                this.isShowDialogue = true;
                                this.goLoading = false
                                return
                            }
                        }
                    }
                }else{
                    this.$message('专家获取失败~')
                }
            })
        },
        //立即咨询点击
        nowGoConsultClick(){
            //this.$message('立即咨询');
            //展开专家列表
            this.isShowTeacherView = !this.isShowTeacherView;
            if(this.isShowTeacherView == true){
                //获取专家列表
                this.getTeacherList();
            }
        },

        //有正在咨询的专家 点击进入当前专家的咨询
        haveDialogBtn(){
            //获取当前正在咨询的专家的信息
            //console.log(this.dialogueTeacherId)
            this.goLoading = true
            if(this.teacherListAll.length == 0){
                //获取专家列表 获取对应信息 然后进入聊天
                this.getTeacherList('go');
            }else{
                for(let a=0;a<this.teacherListAll.length;a++){
                    if(this.teacherListAll[a].userId == this.dialogueTeacherId){
                        this.sendChatData = this.teacherListAll[a];
                        this.sendChatData.dialogueTeacherId = this.dialogueTeacherId;
                        //关闭专家模块
                        this.isShowTeacherView = false;
                        //打开聊天模块
                        this.isShowDialogue = true;
                        this.goLoading = false
                        return
                    }
                }
            }
        },
        //紧急咨询
        jinjiAsk(){
            this.sendChatData = this.teacherListJinJi;
            this.sendChatData.dialogueTeacherId = this.dialogueTeacherId;
            //关闭专家模块
            this.isShowTeacherView = false;
            //打开聊天模块
            this.isShowDialogue = true;
            //this.isHaveDialogue = true
        },
        //展示名片
        openMP(item,index){
            console.log(item)
            //选中名片高亮
            this.teacherMPIndex = index;
            //判断index 在左侧展开还是在右侧展开
            this.mpDirection = ''
            if(index%2 !=0){
                this.mpDirection = 'left'
            }
            //专家详情
            this.teacherMPDetail = item;
            //展示名片内容
            this.isShowTeacherMP = true;
        },
        //关闭名片
        closeMP(){
            //关闭名片内容
            this.isShowTeacherMP = false;
            //关闭名片高亮
            this.teacherMPIndex = null;
        },
        //点击专家 打开聊天模块
        teacherClick(item,index){
            //专家信息
            this.sendChatData = item
            this.sendChatData.dialogueTeacherId = this.dialogueTeacherId;

            //关闭专家模块
            this.isShowTeacherView = false;
            //打开聊天模块
            this.isShowDialogue = true;
            //this.isHaveDialogue = true
        },
        //点击返回到专家列表
        returnTeacherList(){
            this.getTeacherList();
            //获取数据 是否存在正在沟通中的专家
            this.getLastDialogUserId()
            //关闭聊天模块
            this.isShowDialogue = false;
            //打开专家列表
            this.isShowTeacherView = true;
        },
        //结束咨询
        overThatAsk(){
            //二次确认
            this.$confirm('您确定结束当前的咨询吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //触发子组件的结束服务
                this.$refs.chatView.overNowDialogue()
            }).catch(() => {

            });
            //this.isHaveDialogue = false 
        },
        //专家结束咨询的回传
        emitOverFN(data){
            //this.getLastDialogUserId()
            this.isHaveDialogue = data.status
        }
    }
}
</script>
<style lang="scss" scoped>
/***24小时接单 start */
.topGetOrders{
    width: 850px;
    min-height: 130px;
    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
    /*margin-bottom:15px;*/
    .topView{
        width:100%;
        height:130px;
        overflow: hidden;
        background: #0F59A4;
        background-image: url(~@/assets/images/swjcw/miss.png);
        background-size: cover;
        background-repeat: no-repeat;
        .getOrdersLeft{
            width:calc(100% - 230px);
            height:130px;
            float:left;
            .getOrder24{
                width:302px;
                height: 80px;
                float:left;
                margin-left:120px;
                background: red;
                margin-top:27px;
            }
            .getOrderMiss{
                width: 120px;
                height: 120px;
                float:left;
                margin-left:12px;
                background: pink;
                margin-top:6px;
            }
        }
        .getOrdersRight{
            width:230px;
            height:130px;
            float:left;
            .nowGoConsult{
                width: 150px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #FFFFFF;
                font-weight: 700;
                font-size: 18px;
                color: #0F59A4;
                box-shadow: 1px 1px 2px 0px rgba(15,89,164,0.5);
                margin-top:45px;
                -webkit-user-select: none;
                cursor: pointer;
            }
        }
    }
    /**底部的老师及详细的聊天内容 */
    .bottomAskView{
        width:100%;
        /*overflow: hidden;*/
        .isHaveDialogue{
            width:100%;
            height: 60px;
            background: #EEF8FF;
            box-sizing: border-box;
            .dialoguLeftText{
                width:calc(100% - 230px);
                height:60px;
                line-height: 60px;
                float:left;
                box-sizing: border-box;
                padding-left:20px;
                font-weight: 400;
                font-size: 16px;
                color: #0F59A4;
            }
            .dialoguGointoBtn{
                width:230px;
                height:60px;
                float:left;
                .gointoBtn{
                    width:150px;
                    height: 40px;
                    line-height: 40px;
                    background: #0F59A4;
                    box-shadow: 1px 1px 2px 0px rgba(15,89,164,0.5);
                    text-align: center;
                    margin-top:10px;
                    font-weight: 700;
                    font-size: 18px;
                    color: #FFFFFF;
                    cursor:pointer;
                }
            }
        }
        .isShowTeacherView{
            width:100%;
            overflow: hidden;
            box-sizing: border-box;
            padding:20px;
            background: #fff;
            .teacherJinJi{
                width:100%;
                height: 80px;
                background: #EEF8FF;
                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                .teacherJinJiText{
                    width:calc(100% - 208px);
                    height:80px;
                    line-height: 80px;
                    float:left;
                    box-sizing: border-box;
                    padding-left:20px;
                    font-weight: 700;
                    font-size: 20px;
                    color: #FF3752;
                }
                .jinjiRight{
                    width:208px;
                    height:80px;
                    float:left;
                    .jinjiBtn{
                        width: 148px;
                        height: 45px;
                        line-height: 45px;
                        text-align: center;
                        background: #FF3752;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        margin-top:17px;
                        cursor:pointer;
                        font-weight: 700;
                        font-size: 20px;
                        color: #FFFFFF;
                        -webkit-user-select: none;
                    }
                }
            }
            .teacherCG{
                width:100%;
                /*overflow: hidden;*/
                margin-top:10px;
                position: relative;
                .teacherMPViewL{
                    left:0!important;
                }
                .teacherMPView{
                    position: absolute;
                    width: 400px;
                    height: 530px;
                    background: #EEF8FF;
                    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                    z-index:999;
                    top:58px;
                    right:0;
                    .closeMPView{
                        width: 24px;
                        height: 24px;
                        line-height: 20px;
                        text-align: center;
                        position: absolute;
                        top:10px;
                        right:10px;
                        color:#0F59A4;
                        border: 1px solid #0F59A4;
                        border-radius:50%;
                        font-size:24px;
                        cursor:pointer;
                        box-sizing: border-box;
                    }
                    .teacherMPTop{
                        width:100%;
                        height:80px;
                        margin-top: 15px;
                        box-sizing: border-box;
                        padding-left:25px;
                        .teacherMPHeader{
                            width:80px;
                            height:80px;
                            float:left;
                            overflow: hidden;
                            border-radius:50%;
                            img{
                                width:100%;
                            }
                        }
                        .teacherMPn{
                            width:120px;
                            height:45px;
                            margin-left:15px;
                            margin-top:30px;
                            float:left;
                            .teacherName{
                                width:100%;
                                height:18px;
                                font-weight: 700;
                                font-size: 16px;
                                color: #000000;
                                line-height: 18px;
                            }
                            .teacherLevel{
                                width:80px;
                                height:20px;
                                background: #0F59A4;
                                font-weight: 400;
                                text-align: center;
                                font-size: 12px;
                                line-height: 20px;
                                color: #FFFFFF;
                                margin-top:7px;
                                img{
                                    width:14px;
                                    height:14px;
                                    margin-right:7px;
                                    position: relative;
                                    top:2px;
                                }
                            }
                        }
                    }
                    .teacherMPBottom{
                        width:100%;
                        height:423px;
                        overflow-y:auto ;
                        box-sizing: border-box;
                        padding-top:25px;
                        padding-left:20px;
                        padding-right:20px;
                        .teacherSC{
                            width:100%;
                            height:16px;
                            font-weight: 700;
                            font-size: 16px;
                            color: #0F59A4;
                            line-height: 16px;
                            margin-top:15px;
                        }
                        .teacherText{
                            font-weight: 400;
                            font-size: 14px;
                            color: #000000;
                            line-height: 24px;
                            margin-top:10px;
                            text-indent: 28px;
                        }
                    }
                }
                .teacherCGNav{
                    width:100%;
                    height: 45px;
                    background: #EEF8FF;
                    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                    border-bottom:3px solid #0f59a4;
                    p{
                        box-sizing: border-box;
                        padding-left: 20px;
                        line-height: 45px;
                        font-weight: 700;
                        font-size: 20px;
                        color: #0F59A4;
                    }
                }
                .teacherListBox{
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .teacherListCheck{
                        .checkedBorder{
                            width:100%;
                            height: 5px;
                            background: #3C78FF;
                        }
                        .teacherMPD{
                            background:#3C78FF!important;
                        }
                    }
                    .teacherList{
                        width: 400px;
                        height: 170px;
                        background: #EEF8FF;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        margin-top:10px;
                        box-sizing: border-box;
                        padding-left:35px;
                        padding-right:15px;
                        position: relative;
                        .checkedBorder{
                            position: absolute;
                            top:0;
                            left:0;
                        }
                        .teacherStatus{
                            position: absolute;
                            top:0;
                            right:0;
                            width:80px;
                            height: 16px;
                            font-size:14px;
                            line-height: 16px;
                            background: #C4C7CC;
                            text-align: center;
                            color:#ffffff;
                            border-radius:0px 0px 0px 16px;
                        }
                        .teacherListTop{
                            width:100%;
                            height:80px;
                            margin-top:15px;
                            .teacherHeader{
                                width:80px;
                                height:80px;
                                float:left;
                                overflow: hidden;
                                border-radius:50%;
                                img{
                                    width:100%;
                                }
                            }
                            .teacherDesc{
                                width:calc(100% - 80px);
                                height:80px;
                                float:left;
                                background: #EEF8FF;
                                font-weight: 400;
                                font-size: 14px;
                                color: #8C8C8C;
                                line-height: 20px;
                                box-sizing: border-box;
                                padding-left:25px;
                                text-indent: 28px;
                                padding-top:2px;
                                
                            }
                        }
                        .teacherListBottom{
                            width:100%;
                            height:50px;
                            margin-top:10px;
                            .teacherBottomLeft{
                                width:82px;
                                height:50px;
                                float:left; 
                                .teacherName{
                                    width:100%;
                                    height:18px;
                                    font-weight: 700;
                                    font-size: 16px;
                                    color: #000000;
                                    text-align: center;
                                }
                                .teacherMP{
                                    width:82px;
                                    height:20px;
                                    margin-top:10px;
                                    .teacherMPD{
                                        width: 65px;
                                        height: 20px;
                                        line-height: 20px;
                                        background: #0F59A4;
                                        border-radius: 2px 2px 2px 2px;
                                        color:#fff;
                                        text-align: center;
                                        margin:0 auto;
                                        cursor:pointer;
                                        font-size:14px;
                                        img{
                                            width:20px;
                                            height:14px;
                                            position: relative;
                                            top:2px;
                                            margin-right:5px;
                                        }
                                    }
                                }
                            }
                            .teacherBottomRight{
                                width:120px;
                                height:50px;
                                float:right;
                                .teacherStartSialogue{
                                    width: 120px;
                                    height: 40px;
                                    line-height: 40px;
                                    text-align: center;
                                    background: #0F59A4;
                                    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                                    margin-top:10px;
                                    font-weight: 700;
                                    font-size: 18px;
                                    color: #FFFFFF;
                                    cursor: pointer;
                                    -webkit-user-select: none;
                                }
                                .status0{
                                    background: #09B4FF!important;
                                }
                            }
                        }
                    }
                }
            }
        }
        .chatBox{
            .chatTopNav{
                width:100%;
                height: 60px;
                background: #EEF8FF;
                .chatTopNavLeft{
                    width:100px;
                    height:60px;
                    line-height: 60px;
                    float:left;
                    font-weight: 400;
                    font-size: 20px;
                    color: #0F59A4;
                    box-sizing: border-box;
                    padding-left:20px;
                    .chatTopNavReturn{
                        display: inline-block;
                        cursor:pointer;
                        .chatTopNavReturnIcon{
                            display: inline;
                            width:10px;
                            overflow: hidden;
                            float:left;
                        }
                        .chatTopNavReturnText{
                            margin-left:10px;
                        }
                    }
                }
                .chatTopNavText{
                    width:calc(100% - 220px);
                    height:60px;
                    line-height: 60px;
                    float:left;
                    box-sizing: border-box;
                    padding-right:10px;
                    text-align: right;
                    p{
                        font-weight: 400;
                        font-size: 14px;
                        color:#8C8C8C;
                        .redSpan{
                            font-size: 16px;
                            color: #FF3752;
                        }
                    }
                }
                .chatTopNavRight{
                    width:120px;
                    height:60px;
                    float:left;
                    .chatTopNavOverBtn{
                        width: 100px;
                        height: 44px;
                        line-height: 44px;
                        text-align: center;
                        background: #FF3752;
                        font-size: 18px;
                        color: #FFFFFF;
                        cursor: pointer;
                        margin-top:8px;
                        -webkit-user-select: none;
                    }
                }
            }
            .chatBody{
                width:100%;
                height:658px;
                background: #ffffff;
            }
        }
    }
}
/***24小时接单 end */
</style>